import { Link } from 'react-router-dom';
import { seoContent } from '@/mocks/content';

export default function SeoContentSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          {/* Text Content */}
          <div className="lg:w-2/3">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              SEO Guides
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">
              {seoContent.title}
            </h2>
            <div className="space-y-4">
              {seoContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-foreground-600 text-sm leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <Link
                to="/article/pandabuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 cursor-pointer whitespace-nowrap"
              >
                Read Full SEO Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-300 text-foreground-700 text-sm font-semibold hover:border-foreground-400 hover:text-foreground-900 cursor-pointer whitespace-nowrap"
              >
                Pandabuy Sheet
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>

          {/* Side image */}
          <div className="lg:w-1/3 w-full">
            <div className="w-full h-[320px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20mixed%20fashion%20accessories%20including%20round%20sunglasses%20a%20minimalist%20wristwatch%20and%20a%20small%20cognac%20leather%20cardholder%20scattered%20over%20textured%20beige%20linen%20with%20dried%20wheat%20stalks%20soft%20warm%20afternoon%20light%20editorial%20fashion%20still%20life%20photography%20elegant%20composition&width=600&height=700&seq=seo-side-v2-2026&orientation=portrait"
                alt="PandabuySpreadsheet SEO guide"
                className="w-full h-full object-cover object-top rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}